export interface IAudioState {
  canPlay: boolean;
  currentTime: number;
  duration: number;
  hasError: boolean;
  hasStarted: boolean;
  isPlaying: boolean;
}

export class AudioState implements IAudioState {
  canPlay: boolean = false;
  currentTime: number = 0;
  duration: number = 0;
  hasError: boolean = false;
  hasStarted: boolean = false;
  isPlaying: boolean = false;

  constructor(configOverride?: Partial<IAudioState>) {
    if (configOverride) {
      Object.assign(this, configOverride);
    }
  }
}
